import * as React from 'react';
import { Spinner, SpinnerSize} from '@blueprintjs/core';

const ExtSideBarContainer = (props) => {
    if(props.params.sideBarComponent){
        const Component = globalThis['bodaproComponents'][`${props.params.sideBarComponent}`];
        return <Component {...props}/>
    }

    return (
        <div className="bp5-dark p-2">
            <div style={{marginTop: '50px'}}></div>
            <Spinner size={SpinnerSize.LARGE}/>
        </div>
    )
}

export default ExtSideBarContainer;